import { Icon, Menu, Responsive } from './';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Navbar extends Component {
  static Item = Menu.Item;

  state = { mobile: false, collapsed: false };

  onToggle = () =>
    this.setState(state => ({ collapsed: state.mobile && !state.collapsed }));

  onHistoryChange = () => this.setState(state => ({ collapsed: state.mobile }));

  componentDidMount() {
    const { history } = this.props;
    this.unlisten = history.listen(this.onHistoryChange);
  }

  componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  }

  onResponsiveUpdate = (event, { width }) => {
    const mobile = width <= Responsive.onlyMobile.maxWidth;
    this.setState({ mobile, collapsed: mobile });
  };

  render() {
    const { history, logoItem, children, ...props } = this.props;
    const { mobile, collapsed } = this.state;

    const NavMenu = props => <Menu as="nav" {...props} />;

    const { Item } = this.constructor;

    return (
      <Responsive
        as={NavMenu}
        onUpdate={this.onResponsiveUpdate}
        fireOnMount
        stackable={mobile}
        borderless={!mobile}
        className="navbar"
        {...props}
      >
        {logoItem}
        {mobile && (
          <Item onClick={this.onToggle}>
            <span style={{ textAlign: 'right' }}>
              <Icon name="bars" />
              Menu
            </span>
          </Item>
        )}
        {collapsed || children}
      </Responsive>
    );
  }
}

Navbar.propTypes = {
  history: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar.js